import React from 'react';

const CenterLayout = ({children}) => {
    return (
        <div className='center-layout'>
            {children}
        </div>
    );
};

export default CenterLayout;